export const AUTO_GENERATED_OPTION_ID = 'new';
